<template>
  <div v-if="steps.length" class="pi-ai-trace">
    <button type="button" class="pi-ai-trace__toggle" :aria-expanded="isOpen ? 'true' : 'false'" :aria-controls="panelId" @click="toggle">
      <span aria-hidden="true">{{ isOpen ? '▾' : '▸' }}</span> Como cheguei nisso ({{ countText }})
    </button>
    <pi-definition-tooltip class="pi-ai-trace__info" info-key="assistant.trace" label="Como cheguei nisso"/>
    <ol v-show="isOpen" :id="panelId" class="pi-ai-trace__steps">
      <li v-for="step in steps" :key="step.key" class="pi-ai-trace__step">
        <div class="pi-ai-trace__head">
          <strong>{{ step.label }}</strong>
          <code v-if="step.tool" class="pi-ai-trace__tool">{{ step.tool }}</code>
          <span class="pi-badge" :class="'pi-badge--' + step.status.tone">{{ step.status.label }}</span>
          <span v-if="step.partial" class="pi-badge pi-badge--warn">dados parciais</span>
        </div>
        <ul v-if="step.filters.length" class="pi-ai-trace__filters">
          <li v-for="(filter, index) in step.filters" :key="index">{{ filter }}</li>
        </ul>
        <p class="pi-ai-trace__meta">{{ metaText(step) }}</p>
        <ul v-if="step.notes.length" class="pi-ai-trace__notes">
          <li v-for="(note, index) in step.notes" :key="index">{{ note }}</li>
        </ul>
      </li>
    </ol>
  </div>
</template>

<script>
import piDefinitionTooltip from "./piDefinitionTooltip.vue";

let sequence = 0;

export default {
  name: "pi-assistant-trace",
  components: { piDefinitionTooltip },
  props: {
    steps: { type: Array, default: () => [] },
    open: { type: Boolean, default: false },
  },
  data() {
    sequence += 1;
    return { panelId: "pi-ai-trace-" + sequence, isOpen: this.open };
  },
  computed: {
    countText() {
      return this.steps.length === 1 ? "1 consulta" : this.steps.length + " consultas";
    },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    metaText(step) {
      return [step.rowsText, step.latencyText, step.asOfText].filter(Boolean).join(" · ");
    },
  },
};
</script>

<style src="./pi.css"></style>

<style scoped>
.pi-ai-trace {
  margin-top: 12px;
  border-top: 1px dashed #e6e7eb;
  padding-top: 8px;
}

.pi-ai-trace__toggle {
  padding: 0;
  border: 0;
  background: none;
  color: #1b59f8;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.pi-ai-trace__toggle:focus {
  outline: 2px solid #1b59f8;
  outline-offset: 2px;
}

.pi-ai-trace__info {
  margin-left: 4px;
  vertical-align: middle;
}

.pi-ai-trace__steps {
  margin: 8px 0 0;
  padding-left: 18px;
  font-size: 12px;
  color: #3a424e;
}

.pi-ai-trace__step {
  margin-bottom: 8px;
}

.pi-ai-trace__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.pi-ai-trace__tool {
  padding: 0 4px;
  border-radius: 3px;
  background: #f1f2f4;
  color: #1f2933;
  font-size: 11px;
}

.pi-ai-trace__filters,
.pi-ai-trace__notes {
  margin: 2px 0 0;
  padding-left: 16px;
}

.pi-ai-trace__notes {
  color: #6b7280;
}

.pi-ai-trace__meta {
  margin: 2px 0 0;
  color: #6b7280;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piAssistantTrace.vue